import { _ as t } from "../internals/export.js";
import { f as r } from "../internals/function-uncurry-this.js";
var n = Date,
  e = r(n.prototype.getTime);
t({
  target: "Date",
  stat: !0
}, {
  now: function now() {
    return e(new n());
  }
});